import { makeStyles } from 'tss-react/mui';
import { carouselStyles } from '../../styles/jss/carousel';
import { colors } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params, classes) => (Object.assign(Object.assign({ container: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
            position: 'relative',
        },
    }, imageContainer: {
        height: '188px',
        [theme.breakpoints.up('sm')]: {
            height: '428px !important',
        },
        [theme.breakpoints.up('md')]: {
            height: '448px !important',
        },
        [theme.breakpoints.up('xl')]: {
            height: '620px !important',
        },
    }, defaultImage: {
        objectFit: 'cover',
        width: '100% !important',
        height: '188px !important',
        [theme.breakpoints.up('sm')]: {
            height: '428px !important',
        },
        [theme.breakpoints.up('md')]: {
            height: '448px !important',
        },
        [theme.breakpoints.up('xl')]: {
            height: '620px !important',
        },
    }, imageCardContainer: {
        width: '100%',
        margin: '0 auto',
        maxWidth: '100%',
        [theme.breakpoints.up('md')]: {
            width: '86%',
        },
    }, slider: {
        display: 'flex',
        flexDirection: 'row',
    }, carousel: {
        margin: '0 auto',
        padding: `0`,
    }, carouselItem: {
        margin: 0,
        display: 'flex',
    }, videoContainer: {
        [theme.breakpoints.up('xs')]: {
            paddingTop: 0,
        },
        minHeight: '200px',
        width: '100%',
        position: 'relative',
        '& video': {
            cursor: 'pointer',
            height: '188px',
            display: 'block',
            objectFit: 'cover',
            width: '100%',
            position: 'relative',
            zIndex: 1,
            [theme.breakpoints.up('sm')]: {
                height: '428px',
            },
            [theme.breakpoints.up('md')]: {
                height: '448px',
            },
            [theme.breakpoints.up('xl')]: {
                height: '620px',
            },
        },
    }, videoSubContainer: {
        width: '100%',
        margin: '0 auto',
        position: 'relative',
        [theme.breakpoints.up('sm')]: {
            width: '100%',
        },
        [theme.breakpoints.up('md')]: {
            width: '86%',
        },
    } }, carouselStyles(theme, true)), { imageTitle: Object.assign(Object.assign({ backgroundColor: colors.grey.grey1, color: theme.isFlyingFlowers ? colors.black[700] : colors.supplementary.black, textAlign: theme.isFlyingFlowers ? 'center' : 'left', width: '100%', padding: theme.isFlyingFlowers ? '8px 16px !important' : '12px 16px !important' }, theme.typography.small_bold), theme.typographySpacing.none), icon: {
        fontSize: `100px`,
    }, controlsContainer: {
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2,
        [theme.breakpoints.up('xs')]: {
            top: '50%',
        },
        [`& .${classes.icon}`]: {
            fontSize: '5rem',
            color: colors.supplementary.white,
            cursor: 'pointer',
            marginRight: 0,
            '& span': {
                fontSize: 'inherit',
            },
        },
    }, 
    // Portrait video: switch from cover to contain so aspect ratio is preserved
    videoContainerPortrait: {
        '& video': {
            objectFit: 'contain',
            position: 'relative',
            zIndex: 1,
        },
        // Give videoSubContainer the same fixed heights so grey bg fills correctly
        [`& .${classes.videoSubContainer}`]: {
            height: '188px',
            overflow: 'hidden',
            [theme.breakpoints.up('sm')]: {
                height: '428px',
            },
            [theme.breakpoints.up('md')]: {
                height: '448px',
            },
            [theme.breakpoints.up('xl')]: {
                height: '620px',
            },
        },
    }, portraitBlurredBg: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: 'hidden',
        backgroundColor: colors.supplementary.black, // Fallback while image loads
        '& img': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            filter: 'blur(20px) brightness(0.7)',
            scale: '1.1',
        },
    }, videoInnerContainer: {
        position: 'relative',
    } })));
export default useStyles;
